import React from "react";
import {
  HashRouter as Router,
} from "react-router-dom";
import MainRoute from "./main.route";

const AppRouter = () => {
  return (
    <Router>
        <MainRoute/>
    </Router>
  )
}
export default AppRouter;
